
export default {
  name: 'ContentUpgradeComponent',
  props: {
    contentupgrade: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showContentUpgrade() {
      return (
        this.contentupgrade !== null &&
        this.contentupgrade.title &&
        this.contentupgrade.cta_text &&
        this.contentupgrade.cta_url
      )
    },
    title() {
      return this.contentupgrade.title
    },
    ctaText() {
      return this.contentupgrade.cta_text
    },
    ctaUrl() {
      return this.contentupgrade.cta_url
    },
  },
}
